import { motion, useScroll } from "framer-motion";
import { useEffect, useState } from "react";
import { Ticket } from "lucide-react";
import { EVENT_SOLD_OUT } from "@/lib/tickets";

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const { scrollY } = useScroll();

  useEffect(() => {
    const unsub = scrollY.on("change", (y) => setScrolled(y > 40));
    return () => unsub();
  }, [scrollY]);

  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <motion.header
      initial={{ y: -60, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, delay: 0.2, ease: [0.2, 0.8, 0.2, 1] }}
      data-testid="site-nav"
      className={`fixed top-9 sm:top-10 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? "glass" : "bg-transparent"
      } text-[#F5EBD9]`}
    >
      <div className="max-w-[1440px] mx-auto px-6 sm:px-10 lg:px-16 h-16 sm:h-20 flex items-center justify-between">
        <button
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          data-testid="nav-logo"
          className="flex items-center gap-2.5 group"
        >
          <span className="w-2 h-2 rounded-full bg-[#F5892E]" />
          <span className="font-display uppercase text-base sm:text-lg tracking-wide">
            Играта на Имотите
          </span>
        </button>

        <nav className="hidden md:flex items-center gap-8 text-sm font-mono uppercase tracking-[0.22em]">
          <button data-testid="nav-program" onClick={() => scrollTo("program")} className="hover:text-[#F5892E] transition-colors">
            Програма
          </button>
          <button data-testid="nav-speakers" onClick={() => scrollTo("speakers")} className="hover:text-[#F5892E] transition-colors">
            Лектори
          </button>
          <button data-testid="nav-book" onClick={() => scrollTo("book")} className="hover:text-[#F5892E] transition-colors">
            Книгата
          </button>
          <button data-testid="nav-partnership" onClick={() => scrollTo("partnership")} className="hover:text-[#F5892E] transition-colors">
            Партньори
          </button>
        </nav>

        <button
          data-testid="nav-cta-tickets"
          onClick={() => scrollTo(EVENT_SOLD_OUT ? "notify" : "tickets")}
          className="btn-accent px-5 sm:px-7 py-2.5 sm:py-3 rounded-full text-sm sm:text-base font-medium uppercase tracking-wider inline-flex items-center gap-2"
        >
          <Ticket className="w-4 h-4" strokeWidth={2.2} />
          {EVENT_SOLD_OUT ? (
            <span>Запиши се</span>
          ) : (
            <>
              <span className="hidden sm:inline">Билети</span>
              <span className="sm:hidden">Купи</span>
            </>
          )}
        </button>
      </div>
    </motion.header>
  );
}
